import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { portalMetadata, resolvePortal, type PortalMetadata } from "@/lib/portalTabBranding";

function setFavicon(href: string) {
  const existingIcon = document.querySelector<HTMLLinkElement>("#portal-favicon");
  const icon = existingIcon || document.createElement("link");

  icon.id = "portal-favicon";
  icon.rel = "icon";
  icon.type = "image/svg+xml";
  icon.href = href;

  if (!existingIcon) {
    document.head.appendChild(icon);
  }
}

function setAppleTouchIcon(href: string) {
  const icon = document.querySelector<HTMLLinkElement>("#portal-apple-touch-icon");
  if (icon) {
    icon.href = href;
  }
}

function setMetaContent(selector: string, content: string) {
  const tag = document.querySelector<HTMLMetaElement>(selector);
  if (tag) {
    tag.content = content;
  }
}

function setPortalMetadata(metadata: PortalMetadata) {
  document.title = metadata.title;
  setFavicon(metadata.favicon);
  setAppleTouchIcon(metadata.appleTouchIcon);
  setMetaContent('meta[name="description"]', metadata.description);
  setMetaContent('meta[name="theme-color"]', metadata.themeColor);
  setMetaContent('meta[property="og:title"]', metadata.title);
  setMetaContent('meta[property="og:description"]', metadata.description);
  setMetaContent('meta[property="og:image"]', metadata.socialPreview);
  setMetaContent('meta[property="og:image:alt"]', metadata.imageAlt);
  setMetaContent('meta[name="twitter:title"]', metadata.title);
  setMetaContent('meta[name="twitter:description"]', metadata.description);
  setMetaContent('meta[name="twitter:image"]', metadata.socialPreview);
  setMetaContent('meta[name="twitter:image:alt"]', metadata.imageAlt);
}

export function PortalTabBranding() {
  const location = useLocation();

  useEffect(() => {
    const portal = resolvePortal(location.pathname, location.search, window.location.hostname);
    setPortalMetadata(portalMetadata[portal]);
  }, [location.pathname, location.search]);

  return null;
}
